import React, { Component } from 'react';
import autoBind from 'react-autobind';
import TableHelper from 'src/utils/table-helper';
import CircularProgress from 'material-ui/CircularProgress';
import ErrorMessage from 'src/components/misc/error-message';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Entities, Projection } from 'src/common';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import CancellationOptionEditModal from 'src/components/admin/cancellations/cancellation-options-edit-modal';
import Toggle from 'material-ui/Toggle';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import { ButtonColors } from 'src/utils/constants';
import { keysWithNonBlankValues } from 'src/components/misc/validations';
import { IconLabel } from 'src/components/administration/IconLabel';

class CancellationOptionAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        this.props.fetchAll(Entities.CANCELLATION_OPTIONS);
    }

    componentWillReceiveProps(nextProps) {
        const { cancellationOptions } = nextProps;

        if (cancellationOptions.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(cancellationOptions.items.length);
    }

    render() {
        const { cancellationOptions, t } = this.props;

        const finishFetching = this.state.startedFetching && !cancellationOptions.isFetching;
        const tableData = [];

        if (finishFetching && cancellationOptions.items.length > 0) {
            cancellationOptions.items.map(cancellationOption => {
                tableData.push({
                    description: cancellationOption.description.de,
                    createdAt: cancellationOption.createdAt,
                    id: cancellationOption.id,
                    translated: keysWithNonBlankValues(cancellationOption.description),
                    visible: cancellationOption.active,
                });
            });
        }
        return (
            <>
                <legend className="legend">{t('cancellations.options')}</legend>

                <button
                    className="btn btn-xs btn-blue pull-right"
                    onClick={() => {
                        if (this.table) this.table.reset();
                        this.props.openModal({
                            component: CancellationOptionEditModal,
                            componentProps: {
                                isCreate: true,
                            },
                            title: t('cancellations.new_option'),
                            mandatoryFields: true,
                        });
                    }}>
                    {' '}
                    <IconLabel icon="plus" text={t('cancellations.new_option')} />
                </button>

                {(() => {
                    if (!finishFetching) return <CircularProgress />;
                    else if (cancellationOptions.error) return <ErrorMessage object={cancellationOptions} />;
                    else
                        return (
                            <BootstrapTableErrorBoundary>
                                <BootstrapTable
                                    ref={ref => (this.table = ref)}
                                    data={tableData}
                                    exportCSV={true}
                                    striped={true}
                                    hover={true}
                                    condensed={true}
                                    pagination={true}
                                    options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                                    selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                    searchPlaceholder={t('common_phrases.search')}
                                    search={true}>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="id"
                                        width="50"
                                        isKey={true}
                                        export={true}>
                                        {t('common_phrases.id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="description"
                                        dataSort={true}>
                                        {t('cancellations.description')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="translated"
                                        dataSort={true}>
                                        {t('cancellations.translated')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="visible"
                                        width="110"
                                        dataSort={true}
                                        dataFormat={(cell, row) => this.toggleOptionVisibility(row)}>
                                        {t('companies.visible')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        dataField="actions"
                                        width="70"
                                        dataFormat={this.tableActionsFormatter}
                                        export={false}>
                                        {t('common_phrases.actions')}
                                    </TableHeaderColumn>
                                </BootstrapTable>
                            </BootstrapTableErrorBoundary>
                        );
                })()}
            </>
        );
    }

    tableActionsFormatter(cell, option) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        if (this.table) this.table.reset();
                        this.props.openModal({
                            component: CancellationOptionEditModal,
                            componentProps: {
                                isCreate: false,
                                id: option.id,
                            },
                            title: t('cancellations.new_option'),
                            mandatoryFields: true,
                        });
                    }}>
                    <span title={t('user_functionality.edit')} className="glyphicon glyphicon-pencil text-info" />
                </button>
            </div>
        );
    }

    toggleOptionVisibility(option) {
        const { t } = this.props;
        return (
            <Toggle
                toggled={option.visible}
                onToggle={() => {
                    this.props.openModal({
                        component: ConfirmDialog,
                        componentProps: {
                            event: option,
                            onProceedDialog: () => {
                                this.props.patch(
                                    {
                                        active: !option.visible,
                                        id: option.id,
                                    },
                                    Entities.CANCELLATION_OPTIONS,
                                    0,
                                    Projection.FULL,
                                );
                            },
                            closeDrawer: this.handleCloseDrawer,
                            bodyText: this.getToggleCancellationText(option),
                            proceedText: t('common_phrases.yes'),
                            cancelText: t('common_phrases.no'),
                            cancelButtonColor: ButtonColors.NOTIFY,
                            proceedButtonColor: option.active ? ButtonColors.DANGER : ButtonColors.SUCCESS,
                        },
                        title: option.description.de,
                        noButtons: true,
                    });
                }}
            />
        );
    }

    getToggleCancellationText(option) {
        const { t } = this.props;

        if (option.visible) return t('cancellations.deactivation_info');
        return t('cancellations.activation_info');
    }
}

export default withTranslation()(composeModalActions(CancellationOptionAdministration));
